import { render, staticRenderFns } from "./CheckDisclaimerDialog.vue?vue&type=template&id=0bc28154"
import script from "./CheckDisclaimerDialog.vue?vue&type=script&lang=js"
export * from "./CheckDisclaimerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports